import Keycloak from 'keycloak-js';

const keycloakConfig = {
  url: import.meta.env.REACT_APP_KEYCLOAK_URL || 'http://localhost:8080',
  realm: import.meta.env.REACT_APP_KEYCLOAK_REALM || 'x5-pda',
  clientId: import.meta.env.REACT_APP_KEYCLOAK_CLIENT_ID || 'x5-pda-frontend',
  //clientSecret: import.meta.env.REACT_APP_KEYCLOAK_CLIENT_SECRET || '',
  //grant_type: 'client_credentials'
};

const keycloak = new Keycloak(keycloakConfig);

export default keycloak;
